import formatLocalePrice from "./formatLocalePrice";

export const priceNumberFormatter = (amountToFormat, baseCurrency) => {
    if (!amountToFormat && amountToFormat !== 0) {
        return null;
    }
    return formatLocalePrice(amountToFormat, undefined, undefined, undefined, baseCurrency);
};